import _ from 'ckLodash';

var TEXT_NODE = 3;

function getStyles(node) {
    var styles = node.style,
        res = {};
    var i = -1;
    while (styles[++i]) {
        res[styles[i]] = styles[styles[i]];
    }
    if (res['font-family']) {
        var valArr = res['font-family'].replace(/['"\s]/g, '').toLowerCase().split(',');
        res['font-family'] = _.chain(valArr)
            .map(function (val) {
                return val.trim();
            })
            .sortBy()
            .value();
    }
    if (res['text-shadow']) {
        var txtsValArr = res['text-shadow'].split(' ');
        if (/rgb/.test(txtsValArr[0])) {
            txtsValArr.push(txtsValArr.shift());
            res['text-shadow'] = txtsValArr.join(' ');
        }
    }
    return res;
}

function traverse(node, results) {
    if (!node) {
        return null;
    }

    var nodeVal = {};
    nodeVal.tagName = node.tagName;
    if (node.nodeType === TEXT_NODE) {
        nodeVal.text = _.trim(node.textContent);
        if (nodeVal.text !== '') {
            results.push(nodeVal);
        }
    } else {
        nodeVal.classes = _.sortBy(node.classList);
        nodeVal.dataset = _.keys(node.dataset).length && node.dataset;
        nodeVal.dir = node.attributes.dir && node.attributes.dir.value;
        nodeVal.styles = getStyles(node);
        results.push(nodeVal);
    }

    _.forEach(node.childNodes, function (_node) {
        traverse(_node, results);
    });
    return results;
}

function getNormalizedMapOfDOM(str) {
    let fragActual;
    //todo - use isRunningUnderNode
    if (typeof window === 'undefined') {
        // TODO: uncomment me or polyfill node libraries
        // fragActual = require('jsdom').jsdom(str).body;
    } else {
        fragActual = document.createElement('document');
        fragActual.innerHTML = str;
    }
    return traverse(fragActual, []);
}

function basicFixForHtmlStr(htmlStr) {
    return htmlStr.replace(/\n|\t|\r/g, '')
        .replace(/font-weight:\s*700/g, 'font-weight:bold')
        .replace(/font-weight:\s*400/g, 'font-weight:normal');
}

//todo - set extra params to be options object
function htmlEquivalentComparer(actual, expected, ignoreGuard, ignoreBr) {
    actual = basicFixForHtmlStr(actual);
    expected = basicFixForHtmlStr(expected);
    if (ignoreGuard) {
        actual = actual.replace(/\u200b/g, '');
        expected = expected.replace(/\u200b/g, '');
    }

    if (ignoreBr) {
        actual = actual.replace(/<br>/g, '');
        expected = expected.replace(/<br>/g, '');
    }

    var result = {};
    result.pass = _.isEqual(getNormalizedMapOfDOM(actual), getNormalizedMapOfDOM(expected));

    if (!result.pass) {
        //uncomment the following lines when you need to see what was actually compared to decide that we failed
        //console.log(_.repeat('*', 160));
        //window.a = getNormalizedMapOfDOM(actual);
        //window.b = getNormalizedMapOfDOM(expected);
        //console.log('actual:\n', getNormalizedMapOfDOM(actual));
        //console.log('expected:\n', getNormalizedMapOfDOM(expected));
        //console.log(_.repeat('*', 160));
        result.message = 'expected to be html equivalent.\n' +
            actual.replace(/\u2063|\u200b/g, function (char) {
                return escape(char);
            }) +
            '\n' +
            expected.replace(/\u2063|\u200b/g, function (char) {
                return escape(char);
            });
    }
    return result;
}

export default htmlEquivalentComparer;
